export function getCurrentPageName(path) {
    switch (path) {
      case "/super_admin/clients":
        return "Clients";
      case "/super_admin":
        return "Dashboard";
      case "/super_admin/settings":
        return "Settings";
      default:
        return null; // Or you can return a default value or nothing
    }
  }
  